import styled from "styled-components";

const Wrapper = styled.section`
  border-radius: var(--border-radius);
  width: 100%;
  background: var(--background-secondary-color);
  padding: 3rem 2rem 4rem;
  h3 {
    margin-top: 0;
  }
  .form {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    width: 100%;
    /* text-align: center; */
  }
  .form-title {
    margin-bottom: 2rem;
  }
  .form-row {
    margin-bottom: 0;
  }
  .form-center {
    display: grid;
    row-gap: 1rem;
  }
  /* .form-input, */
  .form-textarea {
    padding: 10px;
    border: 1px solid var(--grey-500);
    border-radius: var(--borderRadius);
    width: 100%;
    font-size: 1rem;
    transition: all 0.3s ease;
  }
  .form-textarea {
    min-height: 100px;
    resize: vertical;
  }
  .form-center button {
    align-self: end;
    height: 35px;
    margin-top: 1rem;
  }
  .btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    align-self: flex-end;
    margin-top: 0.5rem;
    button {
      height: 35px;
    }
  }
  .clear-btn {
    background: var(--grey-500);
  }
  .clear-btn:hover {
    background: var(--black);
  }

  @media (min-width: 992px) {
    .form-center {
      align-items: stretch;
      column-gap: 3rem;
      display: grid;
      row-gap: 2rem;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }
    .btn-container {
      display: flex;
      justify-content: flex-start;
      align-items: right;
    }
  }
  @media (min-width: 1130px) {
    .form-center {
      grid-template-columns: 1fr 1fr 1fr;
    }
    .form-center button {
    }
    .btn-container {
      display: flex;
      justify-content: flex-start;
      align-items: right;
      margin-top: 0;
    }
  }
  .form-container.select {
    padding: 10px;
  }
  .form-row select {
    padding: 0 10px;
  }
  .clear-btn {
    background: var(--grey-500);
  }
  .clear-btn:hover {
    background: var(--black);
  }
  .media-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .carousel-container {
    position: relative;
    width: 100%;
    max-width: 100%;
    border: 5px solid var(--);
    background-color: #ffffff;
    box-sizing: border-box;
  }

  .carousel-container .carousel .carousel-slider {
    height: 0;
    padding-top: 56.25%; 
    position: relative;
  }

  .carousel-container .carousel .carousel-slider img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; 
  }

  .carousel-container .carousel .thumbs-wrapper {
    margin-top: 10px; 
  }

  .carousel-container .carousel .thumbs {
    display: flex;
    justify-content: center; 
  }
  .form-row input[type="time"],
  .form-row input[type="date"],
  .form-row input[type="text"],
  .form-row input[type="file"] {
    width: 100%;
  }

  .footer label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  ${'' /* cursor: pointer; */}
  transition: background-color 0.3s ease, transform 0.2s ease;
  min-width: 120px;
  text-align: center;
}

.checkbox-group label:hover {
  background-color: #e6f7ff; 
  transform: scale(1.05); 
}

.checkbox-group label input {
  margin-right: 0.5rem;
}
`;

export default Wrapper;
